(function () {
  const LAST_DEMANDE_KEY = 'db-contact-last-demande';
  const SHOW_SUCCESS_KEY = 'db-contact-show-success';
  const DEMANDE_PATTERN = /^DB-(?:PRO-)?[A-F0-9]{8}$/;

  function createDemandeId() {
    var hex = '';
    try {
      var bytes = new Uint8Array(4);
      crypto.getRandomValues(bytes);
      for (var i = 0; i < bytes.length; i++) {
        hex += bytes[i].toString(16).padStart(2, '0');
      }
    } catch (error) {
      hex = Math.random().toString(16).slice(2, 10);
    }
    return ('DB-' + hex.toUpperCase().padEnd(8, '0')).slice(0, 11);
  }

  function saveDossier(id, subjectValue, bodyValue) {
    var now = new Date().toISOString();
    var lowered = subjectValue.toLowerCase();
    var kind = 'contact';
    if (lowered.indexOf('accès') !== -1 || lowered.indexOf('acces') !== -1) kind = 'access';
    else if (lowered.indexOf('professionnel') !== -1) kind = 'professional';
    else if (lowered.indexOf('commande') !== -1) kind = 'order';

    var dossier = {
      id: id,
      subject: subjectValue.slice(0, 200),
      kind: kind,
      status: 'waiting_db',
      createdAt: now,
      updatedAt: now,
      messages: [
        {
          id: 'MSG-' + id.slice(3),
          author: 'client',
          body: bodyValue.slice(0, 5000),
          attachments: [],
          createdAt: now
        }
      ],
      draft: { body: '', attachments: [] }
    };

    sessionStorage.setItem(LAST_DEMANDE_KEY, id);
    var raw = localStorage.getItem('decor-berbere-dossiers-v1');
    var parsed = raw ? JSON.parse(raw) : { version: 1, dossiers: [] };
    var dossiers = parsed && Array.isArray(parsed.dossiers) ? parsed.dossiers : [];
    dossiers.unshift(dossier);
    localStorage.setItem(
      'decor-berbere-dossiers-v1',
      JSON.stringify({ version: 1, dossiers: dossiers.slice(0, 50) })
    );
  }

  function ensureReferenceInput(form, id) {
    var input = form.querySelector('[data-contact-reference]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'contact[reference]';
      input.setAttribute('data-contact-reference', '');
      form.appendChild(input);
    }
    input.value = id;
    return input;
  }

  function getFormParts(form) {
    return {
      fields: form.querySelector('[data-contact-fields]'),
      success: form.querySelector('[data-contact-success]'),
      errors: form.querySelector('[data-contact-errors]'),
      submitButton: form.querySelector('[data-contact-submit]'),
      againButton: form.querySelector('[data-contact-again]'),
      name: form.querySelector('[data-contact-name]'),
      email: form.querySelector('[data-contact-email]'),
      subject: form.querySelector('[data-contact-subject]'),
      body: form.querySelector('[data-contact-body]'),
      returnTo: form.getAttribute('data-return-to') || window.location.pathname
    };
  }

  function hydrateSuccess(form, demandeId) {
    var parts = getFormParts(form);
    var success = parts.success;
    if (!success || !demandeId) return;
    if (!DEMANDE_PATTERN.test(demandeId)) return;

    var ref = success.querySelector('[data-contact-success-ref]');
    var exchange = success.querySelector('[data-contact-exchange]');
    var label = success.getAttribute('data-reference-label') || 'Référence';
    if (ref) {
      ref.hidden = false;
      ref.textContent = label + ' ' + demandeId;
    }
    if (exchange) {
      try {
        var url = new URL(exchange.getAttribute('href'), window.location.origin);
        url.searchParams.set('demande', demandeId);
        exchange.setAttribute('href', url.pathname + url.search);
      } catch (error) {}
    }
  }

  function showSuccess(form, demandeId) {
    var parts = getFormParts(form);
    if (parts.fields) parts.fields.hidden = true;
    if (parts.errors) {
      parts.errors.hidden = true;
      parts.errors.textContent = '';
    }
    if (parts.success) {
      parts.success.hidden = false;
      hydrateSuccess(form, demandeId);
      if (typeof parts.success.focus === 'function') parts.success.focus();
      parts.success.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  function showFields(form) {
    var parts = getFormParts(form);
    if (parts.success) parts.success.hidden = true;
    if (parts.fields) parts.fields.hidden = false;
    if (parts.body) parts.body.value = '';
    if (parts.errors) {
      parts.errors.hidden = true;
      parts.errors.textContent = '';
    }
    try {
      sessionStorage.removeItem(SHOW_SUCCESS_KEY);
    } catch (error) {}
    if (parts.name) parts.name.focus();
  }

  function restoreSuccessIfNeeded(form) {
    var params = new URLSearchParams(window.location.search);
    var shouldShow = params.get('contact_posted') === 'true';
    var demandeId = '';
    try {
      if (sessionStorage.getItem(SHOW_SUCCESS_KEY) === '1') shouldShow = true;
      demandeId = sessionStorage.getItem(LAST_DEMANDE_KEY) || '';
      sessionStorage.removeItem(SHOW_SUCCESS_KEY);
    } catch (error) {}

    var parts = getFormParts(form);
    if (shouldShow || (parts.success && !parts.success.hidden)) {
      showSuccess(form, demandeId);
    }
  }

  function fillEssayageDraft(form) {
    var params = new URLSearchParams(window.location.search);
    if (params.get('source') !== 'essayage') return;
    var draft = null;
    try {
      draft = JSON.parse(sessionStorage.getItem('db-contact-handoff-v1') || '');
    } catch (error) {
      draft = null;
    }
    if (!(draft && draft.version === 1)) return;
    var parts = getFormParts(form);
    if (parts.name && draft.name) parts.name.value = draft.name;
    if (parts.email && draft.email) parts.email.value = draft.email;
    if (parts.subject && draft.subject) parts.subject.value = draft.subject;
    if (parts.body && draft.message) parts.body.value = draft.message;
  }

  function prepareReference(form) {
    if (form.dataset.contactPrepared === 'true') return form.dataset.contactDemandeId || '';

    var parts = getFormParts(form);
    var subjectValue = parts.subject ? parts.subject.value.trim() : '';
    var bodyValue = parts.body ? parts.body.value.trim() : '';
    var emailValue = parts.email ? parts.email.value.trim() : '';
    if (!emailValue || !bodyValue) return '';

    var id = createDemandeId();
    var subjectWithRef = (subjectValue || 'Contact') + ' [' + id + ']';
    var messageWithRef = id + '\n\n' + bodyValue;

    ensureReferenceInput(form, id);
    if (parts.subject) parts.subject.value = subjectWithRef;
    if (parts.body) parts.body.value = messageWithRef;

    try {
      saveDossier(id, subjectValue, bodyValue);
      sessionStorage.setItem(SHOW_SUCCESS_KEY, '1');
      sessionStorage.setItem(LAST_DEMANDE_KEY, id);
      sessionStorage.removeItem('db-contact-handoff-v1');
    } catch (error) {}

    form.dataset.contactPrepared = 'true';
    form.dataset.contactDemandeId = id;
    form.dataset.contactSubjectOriginal = subjectValue;
    form.dataset.contactBodyOriginal = bodyValue;
    return id;
  }

  function initForm(form) {
    if (!form || form.dataset.contactReady === 'true') return;
    form.dataset.contactReady = 'true';

    var parts = getFormParts(form);
    restoreSuccessIfNeeded(form);
    fillEssayageDraft(form);

    var returnLink = form.querySelector('[data-contact-return]');
    var returnParam = new URLSearchParams(window.location.search).get('return');
    if (returnLink && returnParam && returnParam.charAt(0) === '/') {
      returnLink.setAttribute('href', returnParam);
    }

    if (parts.againButton) {
      parts.againButton.addEventListener('click', function () {
        form.dataset.contactPrepared = 'false';
        form.dataset.contactDemandeId = '';
        showFields(form);
      });
    }
  }

  function initAllForms() {
    document.querySelectorAll('.contact__form').forEach(initForm);
  }

  // Capture phase: enrich fields before Shopify hCaptcha handles submit.
  // Do not preventDefault — captcha requires a normal form POST to send the email.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.classList || !form.classList.contains('contact__form')) return;
      initForm(form);
      prepareReference(form);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllForms);
  } else {
    initAllForms();
  }

  document.addEventListener('shopify:section:load', initAllForms);
})();
